import { BoxedDeliveryIcon } from '@jouzen/ecom-components/icons/BoxedDeliveryIcon';
import { BoxedFingerIcon } from '@jouzen/ecom-components/icons/BoxedFingerIcon';
import { BoxedRingIcon } from '@jouzen/ecom-components/icons/BoxedRingIcon';
import { BoxedSizeKitIcon } from '@jouzen/ecom-components/icons/BoxedSizeKitIcon';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import RichText from '@/app/components/RichText';
import useDisplayBestBuy from '@/app/hooks/useDisplayBestBuy';

import { tValueBestBuy, tValueSizing } from './tValues';

interface ProductSizingModalProps {
  readonly onSizeLinkClick: () => void;
}

const DesktopSizeModal = ({ onSizeLinkClick }: ProductSizingModalProps) => {
  const isBestBuyCountry = useDisplayBestBuy();
  const t = useTranslations();
  return (
    <section className="text-sandstone-500">
      <Typography
        Element="h2"
        variant="h2"
        color="inherit"
        className="pt-5 text-5xl"
      >
        {t('pdp_horizon_sizing_modal_title')}
      </Typography>
      <Typography
        Element="h3"
        variant="h4"
        color="inherit"
        className="py-7 text-base font-normal"
      >
        {t('pdp_size_modal_choose_the_right')}
      </Typography>
      <Typography
        Element="h4"
        variant="h3"
        color="inherit"
        className="border-t border-gray-400 pt-7 text-4xl font-light"
      >
        {t('pdp_size_modal_size_at_home')}
      </Typography>

      <div className="grid grid-cols-2 gap-7 lg:grid-cols-4">
        <div className="col-start-1 col-end-2 py-7">
          <BoxedSizeKitIcon />
          <Typography
            Element="h5"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_1_title')}
          </Typography>
          <Typography
            Element="p"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_1_content')}
          </Typography>
        </div>

        <div className="col-start-2 col-end-3 py-7">
          <BoxedDeliveryIcon />
          <Typography
            Element="h5"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_2_title')}
          </Typography>
          <Typography
            Element="p"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_2_content_04_2025')}
          </Typography>
        </div>

        <div className="col-start-1 col-end-2 py-7 lg:col-start-3 lg:col-end-4">
          <BoxedFingerIcon />
          <Typography
            Element="h5"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_3_title')}
          </Typography>
          <Typography
            Element="p"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_3_content')}
          </Typography>
        </div>

        <div
          className="col-start-2 col-end-3 py-7 lg:col-start-4 lg:col-end-5"
          data-cy="boxed-svg"
        >
          <BoxedRingIcon />
          <Typography
            Element="h5"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_4_title')}
          </Typography>
          <Typography
            Element="p"
            variant="h4"
            color="inherit"
            className="pt-5 text-base font-normal"
          >
            {t('pdp_size_modal_step_4_content')}
          </Typography>
        </div>
      </div>

      {isBestBuyCountry && (
        <>
          <Typography
            Element="h4"
            variant="h3"
            color="inherit"
            className="border-t border-gray-400 pt-7 text-4xl font-light"
          >
            <RichText messageKey="pdp_size_modal_size_in_person_best_buy_title" />
          </Typography>
          <Typography
            Element="p"
            variant="h4"
            color="inherit"
            className="py-7 text-base font-normal"
          >
            <RichText
              messageKey="pdp_size_modal_size_in_person_best_buy_content"
              tValues={tValueBestBuy}
            />
          </Typography>
        </>
      )}
      <Typography
        Element="p"
        variant="h4"
        color="inherit"
        className="border-t border-gray-400 py-7 text-base font-normal"
      >
        <RichText
          messageKey="pdp_size_modal_size_video_text_link"
          tValues={tValueSizing(onSizeLinkClick)}
        />
      </Typography>
    </section>
  );
};
export default DesktopSizeModal;
